import mapValues from 'lodash/mapValues';

export const iconMap = {
  'icon1.png': 'listing_bedrooms',
  'icon2.png': 'listing_bathroom',
  'icon3.png': 'listing_beds',
  listing_guests: "listing_guests",
  listing_bedrooms: "listing_bedrooms",
  listing_beds: "listing_beds",
  listing_bathroom: "listing_bathroom",
  listing_location: "listing_location",
  twitter: 'social_twitter',
  facebook: 'social_facebook',
  youtube: 'social_youtube',
  instagram: 'social_instush',
  dropdown: 'dropdown',
  dropup: 'dropup',
  browse_left: 'browse_left',
  browse_right: 'browse_right',
  'form_sent_success': 'form_sent_success',
  'form_sent_failure': 'form_sent_failure',
  "CM_detector": "amenities/CM_detector",
  "air_condition": "amenities/air_condition",
  "breakfast": "amenities/breakfast",
  "buzzer": "amenities/buzzer",
  "checkin": "amenities/checkin",
  "doorman": "amenities/doorman",
  "dryer": "amenities/dryer",
  "elevator": "amenities/elevator",
  "essentials": "amenities/essentials",
  "events": "amenities/events",
  "family_friendly": "amenities/family_friendly",
  "fire_extinguisher": "amenities/fire_extinguisher",
  "fireplace": "amenities/fireplace",
  "first_aid": "amenities/first_aid",
  "gym": "amenities/gym",
  "hair_dryer": "amenities/hair_dryer",
  "hangers": "amenities/hangers",
  "heating": "amenities/heating",
  "hot_tub": "amenities/hot_tub",
  "iron": "amenities/iron",
  "keypad": "amenities/keypad",
  "kitchen": "amenities/kitchen",
  "laptop": "amenities/laptop",
  "lockbox": "amenities/lockbox",
  "locker": "amenities/locker",
  "parking": "amenities/parking",
  "pets_allowed": "amenities/pets_allowed",
  "pets_live": "amenities/pets_live",
  "pool": "amenities/pool",
  "private_entrance": "amenities/private_entrance",
  "private_livingroom": "amenities/private_livingroom",
  "safety_card": "amenities/safety_card",
  "shampoo": "amenities/shampoo",
  "smartlock": "amenities/smartlock",
  "smoke_detector": "amenities/smoke_detector",
  "smoking": "amenities/smoking",
  "tv": "amenities/tv",
  "washer": "amenities/washer",
  "wheelchair": "amenities/wheelchair",
  "wifi": "amenities/wifi",
  "cats": "amenities/cats",
  "dogs": "amenities/dogs",
  "other_pets": "amenities/other_pets",
  "internet": "amenities/internet",
  "accessibility": "amenities/accessibility",
  "baby": "amenities/baby",
  "bath": "amenities/bath",
  "bbq": "amenities/bbq",
  "beach": "amenities/beach",
  "bed": "amenities/bed",
  "chair": "amenities/chair",
  "cleaning": "amenities/cleaning",
  "coffee": "amenities/coffee",
  "console": "amenities/console",
  "dishes": "amenities/dishes",
  "dishwasher": "amenities/dishwasher",
  "ev": "amenities/ev",
  "garden": "amenities/garden",
  "guard": "amenities/guard",
  "hot_water": "amenities/hot_water",
  "long_term": "amenities/long_term",
  "luggage": "amenities/luggage",
  "microwave": "amenities/microwave",
  "oven": "amenities/oven",
  "patio": "amenities/patio",
  "refrigerator": "amenities/refrigerator",
  "shades": "amenities/shades",
  "stove": "amenities/stove",
  "table": "amenities/table"
};

const requiredIconMap = mapValues(iconMap, name => require(`icons/${name}.svg`));
export default requiredIconMap;


// WEBPACK FOOTER //
// ./src/icons/iconMap.js